import redeemablesData from './redeemables.json';
import wearablesData from './wearables.json';

export const redeemables = redeemablesData;
export const wearables = wearablesData;
